import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { Component, ElementRef, HostListener, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { forkJoin, Observable, Subscription } from 'rxjs'
import { FilterService } from 'src/app/services/filter.service'
import { ApiService } from 'src/app/services/api.service'
import { ChartsModule } from 'src/app/components/shared/charts/charts.module'
import { ProgressIndefinite } from 'src/app/components/shared/progress-indicator/indefinite'

const DAY_OPTIONS = [
  { label: 'Daily',     value: null },
  { label: 'Sundays',    value: 7 },
  { label: 'Mondays',    value: 1 },
  { label: 'Tuesdays',   value: 2 },
  { label: 'Wednesdays', value: 3 },
  { label: 'Thursdays',  value: 4 },
  { label: 'Fridays',    value: 5 },
  { label: 'Saturdays',  value: 6 },
]

const CONTROL_CHART_ITEM = {
  key: 100704,
  config: {
    widgetKey: 100704,
    report_heading: 'Accredo • Status, 17 Jun',
    divid: '',
    chart_type: '',
    prop_list_of_api: '200215',
    data_point: '15',
    link_name1: '',
    link_name2: '',
    height_configuration: { name: 'Dynamic', value: 'dynamic' },
    time_cycle: '',
    default_timeCycle: '',
    widget_header_config: [
      { name: 'Page Header', value: 'page_header', nav_header: false, add_header: true, nav_header_var: 'source_name,file_type_nm,cycle_dt', header_name_isNeed: true, page_header_name: ' ' },
      { name: 'Hidden Toggle', value: 'hidden_toggle' },
      { name: 'Slider', value: 'slider' },
      { name: 'Selection Toggle', value: 'selection_toggle' },
      { name: 'Moving Average', value: 'moving_average' },
      { name: 'Search Box', value: 'search_box' },
      { name: 'Legands', value: 'legends' },
      { name: 'Annotation', value: 'annotation', add_header: true },
      { name: 'Alerts', value: 'alerts' },
      { name: 'Change Status', value: 'change_status' },
      { name: 'Time Cycle', value: 'time_cycle' },
      { name: 'Status Label in Network', value: 'status_label' },
      { name: 'Pagination', value: 'page_size' },
      { name: 'Sort By', value: 'sort_by' },
      { name: 'Follow Up', value: 'follow_up' },
      { name: 'Show By', value: 'show_by' },
      {
        name: 'Icons On Right side', value: 'icons', add_header: true, icon_selected: true,
        iconList: [
          { name: 'info_circle', value: 'info_circle.svg' },
          { name: 'tabular_circle', value: 'tabular_circle.svg' },
          { name: 'union_circle', value: 'union_circle.svg' },
          { name: 'gridload_circle', value: 'gridload_circle.svg' },
          { name: 'shuffle', value: 'setting.svg' , activated: true  },
          { name: 'compare', value: 'compare.svg' },
          { name: 'change_status', value: 'change_status.svg' },
          { name: 'layout', value: 'layout.svg' },
          { name: 'notes', value: 'notes.svg', activated: true },
          { name: 'expand_circle', value: 'expand_circle.svg' },
          {
            name: 'dotmenu_circle', value: 'dotmenu_circle.svg', activated: true, is_Event: true,
            event: [
              { name: 'PDF Chart', value: 'pdf' },
              { name: 'PDF Table', value: 'pdftable' },
              { name: 'Excel', value: 'excel', is_true: true, dispPlayName: 'Export to Excel' },
              { name: 'Server Side Excel', value: 'serverexcel' },
              { name: 'API Export Excel', value: 'apiexcel' },
              { name: 'CSV', value: 'csv' },
              { name: 'PNG', value: 'png', is_true: true, dispPlayName: 'Export to Image' },
              { name: 'Copy to Clipboard', value: 'copy_image', is_true: true, dispPlayName: 'Copy to Clipboard' },
              // {\"name\":\"Copy to Clipboard\",\"value\":\"copy_image\",\"is_true\":true,\"dispPlayName\":\"Copy to Clipboard\"}
            ]
          },
          { name: 'sort', value: 'sort.svg' }
        ],
        searchByKey: [
          { value: 'ALL', name: 'All Columns', param: 'search_val' },
          { value: 'PI', name: 'Patient ID', param: 'patient_id' },
          { value: 'PH', name: 'PHI Columns', param: 'search_val' }
        ]
      }
    ],
    list_of_api1: '',
    list_of_api_col: [
      { api_column_list_key: 20021401, api_key: 200214, api_resp_column_nm: 'source_name', api_resp_column_display_nm: 'Source Name' },
      { api_column_list_key: 20021402, api_key: 200214, api_resp_column_nm: 'kpi_nm', api_resp_column_display_nm: 'KPI Name' },
      { api_column_list_key: 20021403, api_key: 200214, api_resp_column_nm: 'file_type_name', api_resp_column_display_nm: 'File Type Name' },
      { api_column_list_key: 20021404, api_key: 200214, api_resp_column_nm: 'period', api_resp_column_display_nm: 'Period' },
      { api_column_list_key: 20021405, api_key: 200214, api_resp_column_nm: 'kpi_value', api_resp_column_display_nm: 'KPI Value' },
      { api_column_list_key: 20021406, api_key: 200214, api_resp_column_nm: 'file_nm', api_resp_column_display_nm: 'File Name' }
    ],
    list_of_api_col_2: '',
    excel_heading: 'DPM-ED',
    excel_column: '',
    comment_type: { name: 'DPMED', value: 'dpmed' },
    show_data_point: { name: 'true', value: 'true' },
    static_plot: { name: 'true', value: 'true' },
    legend_items: [
      { label: 'anomaly', fill: '#D11044', stroke: '#D11044', symbol: '', symbolFill: 'transparent', selected: true },
      { label: 'buffer values', fill: '#FFCD4A', stroke: '#FFCD4A', symbol: '', symbolFill: 'transparent', selected: false },
      { label: 'normal', fill: '#3AC97C', stroke: '#3AC97C', symbol: '', symbolFill: 'transparent', selected: true },
      { label: 'upper/lower control limits', fill: 'white', stroke: '#E8EAEE', symbol: '...', symbolFill: '#FFCD4A', symbolDY: 1, selected: true },
      { label: 'upper/lower thresholds', fill: '#F9F7F7', stroke: '#E8EAEE', symbol: '', symbolFill: 'transparent', selected: false },
      { label: 'mean (avg)', fill: 'white', stroke: '#E8EAEE', symbol: '_', symbolFill: '#6A76A9', symbolDY: -1, selected: true }
    ],
    list_of_excel_api_col: '',
    list_of_prop_api: { api_key: 200215, api_widget_typ: 'Charts', api_nm: 'dpmed_control_chart_properites', api_display_nm: 'DPMED - Control Chart Properites', api_end_point: 'kpi/get-list-of-value' },
    list_of_api: { api_key: 200214, api_widget_typ: 'Charts', api_nm: 'dpmed_control_chart', api_display_nm: 'DPMED - Control Chart', api_end_point: 'kpi/get-list-of-value' },
    x_axis: { api_column_list_key: 20021404, api_key: 200214, api_resp_column_nm: 'period', api_resp_column_display_nm: 'Period' },
    y_axis: { api_column_list_key: 20021405, api_key: 200214, api_resp_column_nm: 'kpi_value', api_resp_column_display_nm: 'KPI Value' },
    value_column: { api_column_list_key: 20021403, api_key: 200214, api_resp_column_nm: 'file_type_name', api_resp_column_display_nm: 'File Type Name' },
    group_value_column: { api_column_list_key: 20021401, api_key: 200214, api_resp_column_nm: 'source_name', api_resp_column_display_nm: 'Source Name' },
    x_axis_label: 'File Received Date',
    Y_axis_label: 'No of Records',
    zoom_slider: { name: 'true', value: 'true' },
    notes_selected_key: [
      { api_resp_column_nm: 'source_name', api_resp_column_display_nm: 'Source Name' },
      { api_resp_column_nm: 'file_type_name', api_resp_column_display_nm: 'File Type Name' },
      { api_resp_column_nm: 'period', api_resp_column_display_nm: 'Period' }
    ],
    anomaly_mode: '',
    x_var: '',
    y_var: '',
    comments_data: 'kpi_key,data_source_key',
    chart_data: 'kpi_key,source_key'
  }
}

@Component({
    imports: [CommonModule, FormsModule, MatDialogModule, MatIconModule, MatButtonModule, ChartsModule, ProgressIndefinite],
    selector: 'app-control-chart-dialog',
    template: `
    <div class="control-chart-dialog-container">
      <div class="dialog-header">
        <span class="dialog-title">{{ heading }}</span>

        <div class="header-actions">
          <!-- Timecycle day-of-week single-select filter -->
          <div class="day-filter" #dayFilterRef>
            <span class="chipsTag dropdo" style="cursor:pointer;font-weight:600;font-size:10px;"
                  (click)="toggleDayDropdown($event)">
              Timecycle
              <span class="chipBgColor"
                    [style.background-color]="selectedDay.value !== null ? '#FF9A3D' : '#1363DF'">
                {{ selectedDay.label }}
              </span>
            </span>

            <div class="dropdownMenu" *ngIf="dayDropdownOpen" (click)="$event.stopPropagation()">
              <div class="search-container">
                <input type="text" class="search-bar" placeholder="Search..."
                       [(ngModel)]="daySearchTerm" />
              </div>
              <div class="menu-options dynamicHeight">
                <div *ngFor="let opt of filteredDayOptions"
                     class="du-badge-option"
                     [class.selected]="selectedDay.value === opt.value"
                     (click)="selectDay(opt)">
                  {{ opt.label }}
                </div>
              </div>
            </div>
          </div>

          <mat-icon mat-dialog-close class="close-icon" style="color: rgba(138, 152, 171, 1);">close</mat-icon>
        </div>
      </div>

      <div class="dialog-body">
        <!-- Loading overlay -->
        <div class="loader-overlay" *ngIf="isLoading">
          <app-progress-indefinite></app-progress-indefinite>
        </div>

        <app-control-chart
          [heading]="heading"
          [config]="config"
          [data]="data"
          [AllcommentData]="AllcommentData"
          [item]="item"
          [pageKey]="item.key"
          [parentData]="parentData"
          [selectedScope]="selectedScope"
          [error_name]="error_name">
        </app-control-chart>
      </div>
    </div>
  `,
    styles: [`
    :host { display: block; position: relative; overflow: hidden; }
    .control-chart-dialog-container {
      display: flex;
      flex-direction: column;
      width: 100%;
      /* Sized by the chart, capped by the dialog's maxHeight — a fixed height left
         empty space under charts shorter than the popup. */
      height: auto;
      max-height: 100%;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
    }
    .dialog-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 8px 16px;
      background: #f5f5f5;
      border-bottom: 1px solid #e0e0e0;
    }
    .dialog-title {
      font-weight: 600;
      font-size: 16px;
      font-family: 'poppins', sans-serif;
    }
    .header-actions { display: flex; align-items: center; gap: 18px; }
    /* --- Badge (matches filter-badges .chipsTag / .chipBgColor) --- */
    .chipsTag {
      background-color: rgb(230,230,230);
      font-weight: 500;
      margin: 3px;
      padding: 8px;
      border-radius: 10px;
      display: inline-flex;
      align-items: center;
      gap: 5px;
      white-space: nowrap;
      font-family: 'Poppins', sans-serif;
    }
    .chipBgColor {
      background-color: #1363df;
      border-radius: 4px;
      color: #fff;
      padding: 0px 4px;
    }
    /* --- Dropdown (matches filter-badges .dropdownMenu) --- */
    .day-filter { position: relative; z-index: 20; }
    .dropdownMenu {
      position: absolute;
      right: 0;
      top: calc(100% + 2px);
      background: #fff;
      width: 200px;
      margin: 0;
      border-radius: 8px;
      border: 1px solid #ddd;
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
      box-shadow: 0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12);
      z-index: 1000;
    }
    .search-container { margin: 10px; }
    .search-bar {
      width: 100%;
      padding: 5px;
      border: 1px solid #ccc;
      border-radius: 4px;
      box-sizing: border-box;
      font-family: 'Poppins', sans-serif;
      font-size: 12px;
    }
    .menu-options {
      overflow-y: auto;
      min-width: 200px;
      border-top: 1px solid #ddd;
      border-radius: 0 0 8px 8px;
    }
    .menu-options::-webkit-scrollbar { width: 4px; }
    .menu-options::-webkit-scrollbar-track { background: #f1f1f1; border-radius: 4px; }
    .menu-options::-webkit-scrollbar-thumb { background: #1363DF; border-radius: 4px; }
    .menu-options::-webkit-scrollbar-thumb:hover { background: #0d4fb3; }
    .dynamicHeight { max-height: 260px; }
    .du-badge-option {
      padding: 8px 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      font-size: 12px;
      font-family: 'Poppins', sans-serif;
    }
    .du-badge-option.selected { background-color: #ebf5ff; }
    .du-badge-option:hover { background-color: #f1f1f1; border-radius: 4px; }
    /* --- Dialog body --- */
    .dialog-body {
      flex: 1 1 auto;
      position: relative;
      /* Holds the loader overlay (inset: 0) while the chart has no data yet, and keeps the
         popup from resizing under the user once the chart draws at its own height. */
      min-height: 400px;
      overflow: auto;
      padding: 8px;
    }
    /* --- Loader overlay --- */
    .loader-overlay {
      position: absolute;
      inset: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 1);
      z-index: 10;
    }
  `]
})
export class ControlChartDialogComponent implements OnInit, OnDestroy {
  item = CONTROL_CHART_ITEM
  heading: string = ''
  config: any
  data: any = {}
  parentData: any
  AllcommentData: any
  error_name: any
  // Selected tile context handed to the chart so its settings icon (shuffle) reads/writes the
  // properties of THIS selection only — the page-level baseQuery it would otherwise use covers
  // every source/file type on the status overview.
  selectedScope: any

  /**
   * The page's own baseQuery, exactly as it was when this popup opened.
   *
   * Kept so the narrowing below can be undone — FilterService is the app's, not this
   * dialog's (unlike PagePopupComponent, which re-provides its own), so a baseQuery left
   * narrowed to one tile would go on scoping every request the page behind this popup
   * makes after it closes. It is also what the narrowing is recomputed FROM each time,
   * so changing the day-of-week filter cannot stack one tile's scope on the last one's.
   */
  private pageBaseQuery: any

  // --- Timecycle day-of-week single-select state ---
  readonly dayOptions = DAY_OPTIONS
  selectedDay: typeof DAY_OPTIONS[0] = DAY_OPTIONS[0]
  daySearchTerm = ''
  dayDropdownOpen = false
  isLoading = false
  private currentDayOfWeek: number | null | undefined = undefined

  @ViewChild('dayFilterRef') private dayFilterRef!: ElementRef<HTMLElement>

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.dayDropdownOpen && this.dayFilterRef && !this.dayFilterRef.nativeElement.contains(event.target as Node)) {
      this.dayDropdownOpen = false
    }
  }

  get filteredDayOptions() {
    const term = this.daySearchTerm.trim().toLowerCase()
    return term ? this.dayOptions.filter(o => o.label.toLowerCase().includes(term)) : this.dayOptions
  }

  toggleDayDropdown(event: MouseEvent): void {
    event.stopPropagation()
    this.dayDropdownOpen = !this.dayDropdownOpen
  }

  selectDay(opt: typeof DAY_OPTIONS[0]): void {
    this.selectedDay = opt
    this.dayDropdownOpen = false
    this.daySearchTerm = ''
    this.currentDayOfWeek = opt.value ?? undefined
    this.reqSubcription.forEach(s => s.unsubscribe())
    this.reqSubcription = []
    this.loadApiData()
  }
  // -------------------------------------------------

  private reqSubcription: Subscription[] = []

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private filterService: FilterService,
    private httpClient: HttpClient,
    private apiService: ApiService
  ) {}

  ngOnInit(): void {
    this.heading = this.dialogData?.heading || this.item.config.report_heading

    // Pre-select the day matching the record's day_of_the_week
    const initialDay = this.dialogData?.extraPayload?.day_of_the_week
    if (initialDay != null) {
      const match = this.dayOptions.find(o => o.value === Number(initialDay))
      this.selectedDay = match ?? DAY_OPTIONS[0]
      this.currentDayOfWeek = this.selectedDay.value ?? undefined
    }

    // Before either load below: both read baseQuery, and so does everything the chart
    // renders inside itself.
    this.pageBaseQuery = this.filterService.baseQuery
    this.narrowBaseQueryToTile()

    this.loadApiData()
    this.getCommentsData()
  }

  loadApiData(): void {
    const apiConfig = this.item.config
    const parentApiKey = apiConfig.list_of_prop_api?.api_key
    const childApiKey = apiConfig.list_of_api?.api_key

    if (this.filterService.isEmptyObject(this.filterService.baseQuery)) return

    this.isLoading = true

    // Re-narrowed on every load, because the day-of-week filter is part of the scope and
    // selectDay() comes back through here.
    this.narrowBaseQueryToTile()

    const tileScope = this.buildTileScope()

    // Same selection the chart is drawn for — the settings icon reuses it for its properties
    // fetch/save. Empty values are dropped so they cannot blank out a baseQuery field.
    this.selectedScope = this.stripEmpty({ ...tileScope, module_key: this.apiService.getModuleKey() })

    // baseQuery already carries this tile (narrowBaseQueryToTile), but `tileScope` is still
    // spread raw on top — undefined values and all — because this request relies on them to
    // CLEAR a page-level value: a static screen empties file_type_nm in buildCcNavData
    // precisely so the series is not filtered by a display name. The narrowing drops empty
    // keys, which is right for a note and wrong here.
    const commonQuery = {
      ...this.filterService.baseQuery,
      ...tileScope,
      report_typ: 'D',
      time_cycle: this.filterService.report_type,
      report_key: undefined,
      module_key: this.apiService.getModuleKey()
    }

    const endPoint = (this.item.config as any)['list_of_api_endpoint'] || ''
    const url = `${this.apiService.apiBaseUrl}/${endPoint || this.apiService.executionUrl}`

    const parentRequest: Observable<any[]> = this.httpClient.post<any[]>(url, { ...commonQuery, api_key: parentApiKey })
    const childRequest: Observable<any[]> = this.httpClient.post<any[]>(url, { ...commonQuery, api_key: childApiKey })

    const sub = forkJoin([parentRequest, childRequest]).subscribe({
      next: ([parentRes, childRes]: [any[], any[]]) => {
        this.parentData = parentRes || []
        this.data = childRes?.length ? childRes : []
        this.error_name = ''
        this.isLoading = false
      },
      error: (err: any) => {
        this.parentData = []
        this.data = []
        this.error_name = friendlyApiErrorMessage(err)
        this.isLoading = false
      }
    })

    this.reqSubcription.push(sub)
  }

  /**
   * This tile's own scoping: what the double-click was ON.
   *
   * extraPayload mirrors what storingPayloadAndFilterForGrid puts into
   * filterService.baseQuery on the real control chart page (payloadData + filterData
   * from nav_configuration); the rest is read off navData the same way
   * status-overview.buildExtraPayload reads it.
   *
   * Returned raw — undefined values included — because the chart's request relies on
   * them to clear the page-level value (see commonQuery). Callers that must not send
   * empty keys pass it through stripEmpty().
   */
  private buildTileScope(): any {
    const baseExtra: any = this.dialogData?.extraPayload || {}
    const navData: any = this.dialogData?.navData || {}
    return {
      ...baseExtra,
      cycle_dt: navData.cycle_dt,
      file_type_nm: navData.file_type_nm,
      source_nm: navData.source_name,
      day_of_the_week: this.currentDayOfWeek ?? undefined
    }
  }

  private stripEmpty(payload: any): any {
    return Object.entries(payload || {})
      .filter(([, value]) => value !== undefined && value !== null && value !== '')
      .reduce((out: any, [key, value]) => ({ ...out, [key]: value }), {})
  }

  /**
   * Narrow FilterService.baseQuery to the double-clicked tile for as long as this popup
   * is open.
   *
   * baseQuery is what every request in here is built from — the chart's own (commonQuery),
   * and every note call the chart makes inside itself: api_key 100132 with report_typ 'S'
   * to list them and 'I' / 'U' / 'D' to file, edit and remove one, all of which reach it
   * through FilterService.commentsQuery(). So putting the tile's scoping INTO baseQuery is
   * what makes the notes describe the same selection the chart does, without a second
   * channel for the same information: the reused chart is handed nothing new and stays as
   * it is, and anything else that popup ever renders is scoped for free.
   *
   * It is the same thing PagePopupComponent does for the detail-page popup, where
   * extraPayload becomes `extraNavPayload` and FilterService merges it into that popup's
   * private baseQuery — this is the in-place version, for a dialog that shares the app's
   * FilterService rather than providing its own. Hence pageBaseQuery and the restore in
   * ngOnDestroy.
   *
   * Rebuilt from pageBaseQuery every time rather than layered onto what is already there,
   * so re-running it (the day filter) replaces the previous tile's scope instead of
   * accumulating it. Empty values are dropped: a note is keyed by the fields it is given,
   * so a key with no value is noise at best and a filter for nothing at worst. A falsy
   * refresh_no goes too — the notes API stores 0 as NULL and then cannot match it back,
   * which is the normalisation getCommentsData() used to do by hand.
   */
  private narrowBaseQueryToTile(): void {
    const scope = this.stripEmpty({
      ...this.buildTileScope(),
      module_key: this.apiService.getModuleKey()
    })
    if (!scope.refresh_no) delete scope.refresh_no

    this.filterService.baseQuery = { ...(this.pageBaseQuery || {}), ...scope }
  }

  /**
   * The tile's notes. Only says what the call IS — commentsQuery() merges baseQuery, which
   * narrowBaseQueryToTile() has already narrowed to this tile, so the scoping does not need
   * restating here and cannot drift from what the chart is drawn with.
   */
  getCommentsData(): void {
    const postdata: any = {
      report_typ: 'S',
      comment_typ: this.item.config.comment_type.value || 'dpmed',
      api_key: '100132'
    }
    const sub = this.filterService.commentsQuery(postdata).subscribe({
      next: (res: any) => { this.AllcommentData = res || [] },
      error: () => { this.AllcommentData = [] }
    })

    this.reqSubcription.push(sub)
  }

  ngOnDestroy(): void {
    // Hand the page back the baseQuery it had. FilterService is the app's, so a baseQuery
    // left narrowed to one tile would scope everything the page behind this popup asks for
    // once it closes.
    this.filterService.baseQuery = this.pageBaseQuery
    this.reqSubcription.forEach(s => s.unsubscribe())
  }
}
